import React from 'react';
import PortalFormacionLayout from './portal-formacion-layout';

export default class PortalFormacion extends React.Component<{}, {}> {
    render(){
        return(
            <PortalFormacionLayout/>
        )
    }
}